import { CircularProgress, Typography } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

import NotesListItem from "./NotesListItem";

export default function NotesList({
  data,
  handleEdit,
  handleOnClickPin,
  isLoading,
  notePermissionsHook,
}) {
  if (isLoading) {
    return <CircularProgress style={{ color: HNSColors.secondary[500] }} />;
  }

  if (!data || data.length === 0) {
    return <Typography className="text-center">No notes</Typography>;
  }

  return (
    <div className="absolute bottom-0 top-0 flex w-full flex-col overflow-y-auto px-2 [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
      <div className="flex h-full flex-col gap-4">
        {Array.isArray(data) &&
          data.map((note) => (
            <NotesListItem
              key={note?.id}
              data={note}
              handleEdit={handleEdit}
              handleOnClickPin={handleOnClickPin}
              notePermissionsHook={notePermissionsHook}
            />
          ))}
      </div>
    </div>
  );
}
